<svg width="20" height="2" viewBox="0 0 20 2" xmlns="http://www.w3.org/2000/svg"><path d="M0 1a1 1 0 011-1h18a1 1 0 110 2H1a1 1 0 01-1-1z"/></svg>